export default {"src":"/_next/static/media/lifebuoy_64.3852b64c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};